import React, { ReactNode } from 'react';
import CardConainer from '../CardContainer';
import Text from '../Text';
import './ActionCard.less';

export type ActionCardProps = {
  action?: ReactNode;
  title?: string | ReactNode;
  cardStyle?: React.CSSProperties;
};

const TActionCard: React.FC<ActionCardProps> = ({
  action,
  title,
  cardStyle,
}) => {
  return (
    <CardConainer borderd style={cardStyle}>
      <div className="t-action-card-wrapper">
        <div className="t-action-card-title-wrapper">
          {typeof title === 'string' ? (
            <Text bold level={2} rows={1} textColor="dark-100">
              {title}
            </Text>
          ) : (
            <div>{title}</div>
          )}
        </div>
        <div className="t-action-wrapper">{action}</div>
      </div>
    </CardConainer>
  );
};

export default TActionCard;
